export enum ColorModeEnum {
  LIGHT = 'light',
  DARK = 'dark'
}
